import { mergeRefs } from "@faire/slate/lib/mergeRefs";
import { useFloatingContext } from "@faire/slate/private/floating/FloatingContext";
import { useListItem } from "@floating-ui/react";

import { useMenuContext } from "./MenuContext";

type IUserProps<T extends HTMLElement> = {
  ref?: React.Ref<T>;
  onClick?: (event: React.MouseEvent<T>) => void;
};

export const useGetMenuItemProps = <
  T extends HTMLElement = HTMLButtonElement,
>() => {
  const { ref: refListItem, index } = useListItem();
  const { setOpen, propGetters } = useFloatingContext();
  const { activeIndex } = useMenuContext();

  const isActive = index === activeIndex;

  const getProps = ({ ref: refProp, onClick }: IUserProps<T> = {}) => {
    const ref = mergeRefs<T>(refListItem, refProp);
    return propGetters.getItemProps({
      ref,
      role: "menuitem",
      tabIndex: isActive ? 0 : -1,
      ...{ "data-active": isActive }, // using spread operator to avoid type error
      onClick(event: React.MouseEvent<T>) {
        setOpen(false);
        onClick?.(event);
      },
    });
  };

  return { getProps };
};
